/* eslint-disable no-use-before-define */
/* eslint-disable react/no-array-index-key */
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { get } from 'lodash';
import { toast } from 'react-toastify';
import L from 'leaflet';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import 'dayjs/locale/pt-br';
import { Grid, Box, Button } from '@mui/material';
import { FaFlag, FaFileExcel } from 'react-icons/fa6';
import { ContainerFlex, MapaContainer, TabelaContainer, Table } from './styled';
import { ContainerPainel, Title } from '../../styles/GlobalStyles';
import axios from '../../services/axios';
import Loading from '../../components/Loading';
import 'leaflet/dist/leaflet.css';
import markerIcon from '../../assets/img/marker-icon-red.png';
import markerShadow from '../../assets/img/marker-shadow.png';

dayjs.locale('pt-br'); // ajuste o caminho conforme necessário

// const textData = 'Ranking Médio Combustível';
// const tableRoute = 'posto';
const tableData = 'despesas';

// Definição do ícone personalizado
const iconePosto = new L.Icon({
  iconUrl: markerIcon,
  iconSize: [25, 41], // Tamanho do ícone
  iconAnchor: [12, 41], // Ancoragem (base do ícone toca o mapa)
  popupAnchor: [1, -34], // Posição do popup
  shadowUrl: markerShadow,
  shadowSize: [41, 41], // Tamanho da sombra
});

const exportToExcel = (data, fileName) => {
  if (!data || data.length === 0) return;

  // Converte os dados JSON em uma planilha
  const ws = XLSX.utils.json_to_sheet(data);

  // Cria um arquivo Excel e adiciona a planilha
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Combustível por Posto');

  // Gera o buffer do arquivo Excel
  const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });

  // Cria um Blob para download
  const dataBlob = new Blob([excelBuffer], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  });

  saveAs(dataBlob, `${fileName}.xlsx`);
};

// eslint-disable-next-line react/prop-types
function ExportExcelButton({ data }) {
  return (
    <FaFileExcel
      onClick={() => exportToExcel(data, 'combustivel_posto')}
      style={{
        position: 'absolute',
        left: 0,
        fontSize: '30px',
        color: 'green',
        cursor: 'pointer',
      }}
      title="Exportar para Excel"
    />
  );
}

export default function MapaPostos() {
  const [ranking, setRanking] = useState([]);
  const [detalhes, setDetalhes] = useState([]);
  const [dtinicial, setDtInicial] = useState(dayjs().subtract(1, 'day')); // Dia anterior
  const [dtfinal, setDtFinal] = useState(dayjs()); // Data atual
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  async function fetchAll() {
    const params = {};
    let formErrors = true;

    if (dtinicial) {
      params.dtinicial = dtinicial;
    } else {
      toast.error('Informe a Data Inicial');
      formErrors = false;
    }
    if (dtfinal) {
      params.dtfinal = dtfinal;
    } else {
      toast.error('Informe a Data Final');
      formErrors = false;
    }

    if (formErrors) {
      try {
        setIsLoading(true);
        const response = await axios.get(`/${tableData}/ranking_postos`, {
          params,
        });
        setRanking(response.data.rancking);
        setDetalhes(response.data.detalhes);
      } catch (err) {
        const status = get(err, 'response.status', 0);
        const errors = get(err, 'response.data.errors', []);

        if (status === 400) errors.map((error) => toast.error(error));
        navigate(`/home`);
      } finally {
        setIsLoading(false);
      }
    }
  }

  function limparFiltros() {
    setDtInicial(dayjs().subtract(1, 'day'));
    setDtFinal(dayjs());
    setRanking([]);
  }

  return (
    <ContainerPainel>
      <Title>Preço Diesel</Title>
      <Box
        component="form"
        noValidate
        autoComplete="off"
        sx={{
          '& .MuiTextField-root': { m: 0, width: { xs: '100%', sm: '100%' } },
          mb: 2,
        }}
      >
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <LocalizationProvider
              dateAdapter={AdapterDayjs}
              adapterLocale="pt-br"
            >
              <DatePicker
                required
                label="Data Inicial"
                size="small"
                value={dtinicial}
                onChange={(date) => setDtInicial(date)}
                format="DD/MM/YYYY"
                inputFormat="DD/MM/YYYY"
              />
            </LocalizationProvider>
          </Grid>
          <Grid item xs={12} sm={6}>
            <LocalizationProvider
              dateAdapter={AdapterDayjs}
              adapterLocale="pt-br"
            >
              <DatePicker
                required
                label="Data Final"
                size="small"
                value={dtfinal}
                onChange={(date) => setDtFinal(date)}
                format="DD/MM/YYYY"
                inputFormat="DD/MM/YYYY"
              />
            </LocalizationProvider>
          </Grid>
          <Grid item xs={12}>
            <Button
              variant="contained"
              color="primary"
              onClick={() => fetchAll()}
              style={{ marginRight: '10px' }}
            >
              Filtrar
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={() => limparFiltros()}
            >
              Limpar Filtros
            </Button>
          </Grid>
        </Grid>
      </Box>
      <ContainerFlex>
        {/* Tabela com os dados */}
        <TabelaContainer>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              position: 'relative',
            }}
          >
            <h3 style={{ flex: 1, textAlign: 'center', marginBottom: '5px' }}>
              Combustível por Posto
              <ExportExcelButton data={detalhes} />
            </h3>
          </div>

          <Table>
            <thead>
              <tr>
                <th style={thStyle}>#</th>
                <th style={thStyle}>Posto</th>
                <th style={thStyle}>Último</th>
                <th style={thStyle}>Média</th>
                <th style={thStyle}>Negociado</th>
                <th style={thStyle}>Município</th>
                <th style={thStyle}>UF</th>
              </tr>
            </thead>
            <tbody>
              {ranking.map((posto, index) => (
                <tr key={index} style={index % 2 === 0 ? rowEven : rowOdd}>
                  <td style={tdStyle}>
                    {Number(posto.ultimo_valor_lancado) >
                    Number(posto.valor_acordado) ? (
                      <FaFlag style={{ color: 'red' }} />
                    ) : (
                      <FaFlag style={{ color: 'green' }} />
                    )}
                  </td>
                  <td style={tdStyle}>{posto.posto_nome}</td>
                  <td style={tdStyle}>
                    {posto.ultimo_valor_lancado?.toFixed(2)}
                  </td>
                  <td style={tdStyle}>
                    {posto.preco_medio_por_litro?.toFixed(2)}
                  </td>
                  <td style={tdStyle}>{posto.valor_acordado?.toFixed(2)}</td>
                  <td style={tdStyle}>{posto.Posto.Local.municipio}</td>
                  <td style={tdStyle}>{posto.Posto.Local.uf}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        </TabelaContainer>
        <MapaContainer>
          <MapContainer
            center={[-26.3051, -48.8461]} // Coordenadas iniciais
            zoom={12}
            style={{ height: '500px', width: '100%' }}
          >
            <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />

            {ranking && ranking.length > 0 ? (
              ranking
                .filter(
                  (posto) =>
                    posto.Posto.latitude !== undefined &&
                    posto.Posto.longitude !== undefined
                )
                .map((posto, index) => (
                  <Marker
                    key={index}
                    position={[posto.Posto.latitude, posto.Posto.longitude]}
                    icon={iconePosto}
                  >
                    <Popup>
                      <strong>{posto.posto_nome}</strong>
                      <br />
                      Preço médio: R$ {posto.preco_medio_por_litro?.toFixed(2)}
                    </Popup>
                  </Marker>
                ))
            ) : (
              <p>Nenhum posto disponível.</p>
            )}
          </MapContainer>
        </MapaContainer>
      </ContainerFlex>

      <Loading isLoading={isLoading} />
    </ContainerPainel>
  );
}

// Estilos da tabela
const thStyle = {
  backgroundColor: '#f4f4f4',
  padding: '8px',
  borderBottom: '2px solid #ddd',
  textAlign: 'left',
};

const tdStyle = {
  padding: '8px',
  borderBottom: '1px solid #ddd',
  textAlign: 'left',
};

const rowEven = { backgroundColor: '#ffffff' };
const rowOdd = { backgroundColor: '#f9f9f9' };
